import React from 'react';
import { useTranslation } from 'react-i18next';

import './DisplayStyleControl.module.css';

const DisplayStyleControl = ({ displayStyle, setDisplayStyle }) => {
  const { t } = useTranslation();
  return (
    <div styleName="switch">
      <button
        onClick={() => setDisplayStyle('grid')}
        disabled={displayStyle === 'grid'}
        title={t('Display as grid')}
      >
        <i className="fl-grid_view" />
      </button>
      <button
        onClick={() => setDisplayStyle('list')}
        disabled={displayStyle === 'list'}
        title={t('Display as list')}
      >
        <i className="fl-format_list_bulleted" />
      </button>
    </div>
  );
};

export default DisplayStyleControl;
